module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.fd62177a513efa29f3b7.js");
};